'use client';

export default function Footer() {
  return (
    <footer
      className="border-t py-8 px-5"
      style={{ borderColor: 'rgba(0,0,0,0.08)', background: '#FFFFFF' }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Left: copyright + legal */}
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" style={{ color: '#7A95AD' }}>
          <span>© 2026 Hendrick Loodgieterij</span>
        </div>

        {/* Center: links */}
        <div className="flex items-center gap-6 text-sm font-medium" style={{ color: '#7A95AD' }}>
          <a href="#" className="hover:text-brand-fg transition-colors">Juridische vermeldingen</a>
          <a href="#" className="hover:text-brand-fg transition-colors">AV</a>
          <a href="#" className="hover:text-brand-fg transition-colors">Consumentenrechten</a>
          <a href="#" className="hover:text-brand-fg transition-colors">Privacy</a>
        </div>

        {/* Right: payment methods */}
        <div className="flex flex-col items-center md:items-end gap-2">
          <span className="text-xs font-medium" style={{ color: '#7A95AD' }}>Geaccepteerde betaalmethoden</span>
          <div className="flex items-center gap-3">
            {/* Bancontact */}
            <div className="flex flex-col items-center gap-1">
              <div
                className="w-12 h-8 rounded-md flex items-center justify-center shadow-sm border"
                style={{ background: '#005498', borderColor: '#e2e8f0' }}
                title="Bancontact"
              >
                <svg viewBox="0 0 48 32" width="40" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="48" height="32" rx="4" fill="#005498"/>
                  <rect x="4" y="10" width="18" height="12" rx="2" fill="#FFFFFF"/>
                  <rect x="26" y="10" width="18" height="12" rx="2" fill="#E4002B"/>
                  <text x="7" y="20" fontSize="7" fontWeight="bold" fill="#005498" fontFamily="Arial">BC</text>
                  <text x="29" y="20" fontSize="7" fontWeight="bold" fill="#FFFFFF" fontFamily="Arial">BC</text>
                </svg>
              </div>
              <span className="text-xs" style={{ color: '#7A95AD' }}>Bancontact</span>
            </div>

            {/* Payconiq */}
            <div className="flex flex-col items-center gap-1">
              <div
                className="w-12 h-8 rounded-md flex items-center justify-center shadow-sm border"
                style={{ background: '#FF4785', borderColor: '#e2e8f0' }}
                title="Payconiq"
              >
                <svg viewBox="0 0 48 32" width="40" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="48" height="32" rx="4" fill="#FF4785"/>
                  <circle cx="24" cy="16" r="8" fill="white" fillOpacity="0.2"/>
                  <circle cx="24" cy="16" r="5" fill="white"/>
                  <circle cx="24" cy="16" r="2.5" fill="#FF4785"/>
                </svg>
              </div>
              <span className="text-xs" style={{ color: '#7A95AD' }}>Payconiq</span>
            </div>

            {/* Carte de crédit */}
            <div className="flex flex-col items-center gap-1">
              <div
                className="w-12 h-8 rounded-md flex items-center justify-center shadow-sm border"
                style={{ background: '#1A1F71', borderColor: '#e2e8f0' }}
                title="Kredietkaart"
              >
                <svg viewBox="0 0 48 32" width="40" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="48" height="32" rx="4" fill="#1A1F71"/>
                  <rect x="4" y="12" width="40" height="5" fill="#F7B600" fillOpacity="0.9"/>
                  <rect x="4" y="20" width="14" height="4" rx="1" fill="white" fillOpacity="0.7"/>
                  <circle cx="30" cy="16" r="6" fill="#EB001B" fillOpacity="0.9"/>
                  <circle cx="38" cy="16" r="6" fill="#F79E1B" fillOpacity="0.9"/>
                </svg>
              </div>
              <span className="text-xs" style={{ color: '#7A95AD' }}>Kredietkaart</span>
            </div>

            {/* Cash */}
            <div className="flex flex-col items-center gap-1">
              <div
                className="w-12 h-8 rounded-md flex items-center justify-center shadow-sm border"
                style={{ background: '#2D7D46', borderColor: '#e2e8f0' }}
                title="Cash"
              >
                <svg viewBox="0 0 48 32" width="40" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="48" height="32" rx="4" fill="#2D7D46"/>
                  <circle cx="24" cy="16" r="8" fill="white" fillOpacity="0.15"/>
                  <text x="20" y="20" fontSize="12" fontWeight="bold" fill="white" fontFamily="Arial">€</text>
                </svg>
              </div>
              <span className="text-xs" style={{ color: '#7A95AD' }}>Cash</span>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}